/* eslint-disable import/no-anonymous-default-export */
export default {
  ANIMATION_LENGTH: 400,
  ANIMATION_LENGTH_SHORT: 600,
  ANIMATION_LENGTH_LONG: 1000,
  MULTIANIMATION: 0.6,
  OR: "Or",
  N_A: "N/a",
  NEW: "New",
  YES: "Yes",
  QTY: "Qty",
  HSN: "Hsn",
  ALL: "All",
  DAY: "Day",
  URL: "Url",
  ADD: "Add",
  SET: "Set",
  ANK: "Bank",
  OOPS: "Oops",
  RULE: "Rule",
  EDIT: "Edit",
  TIME: "Time",
  YEAR: "Year",
  RTGS: "RTGS",
  BYOK: "BYOK",
  TOTP: "Totp",
  NEFT: "NEFT",
  NEXT: "Next",
  CGST: "CGST",
  SGST: "SGST",
  IGST: "IGST",
  CITY: "City",
  TEST: "Test",
  MORE: "More",
  TYPE: "Type",
  OPEN: "Open",
  VIEW: "View",
  NAME: "Name",
  DATE: "Date",
  LOAD: "Load",
  RATE: "Rate",
  PAID: "Paid",
  DATES: "Dates",
  ALERT: "Alert",
  GO_TO: "Go to",
  TOTAL: "Total",
  USERS: "Users",
  LAKHS: "Lakhs",
  ALIAS: "Alias",
  DATED: "Dated",
  ROLES: "Roles",
  CLOSE: "Close",
  LOGIN: "Login",
  BRAND: "Brand",
  MODEL: "Model",
  LEAVE: "Leave",
  APPLY: "Apply",
  FETCH: "Fetch",
  DEBIT: "Debit",
  CLEAR: "Clear",
  SHARE: "Share",
  FILES: "Files",
  GSTIN: "GSTIN",
  FIELD: "Field",
  SETUP: "Set up",
  AWS_TEXT: "AWS",
  MANUAL: "Manual",
  ALERTS: "Alerts",
  VERIFY: "Verify",
  LOGOUT: "Logout",
  UPDATE: "Update",
  SELECT: "Select",
  AMOUNT: "Amount",
  UNPAID: "Unpaid",
  RECENT: "Recent",
  CRORES: "Crores",
  CANCEL: "Cancel",
  IMAGES: "Images",
  CUSTOM: "Custom",
  FILTER: "Filter",
  REJECT: "Reject",
  CREATE: "Create",
  ACTIVE: "Active",
  ASSIGN: "Assign",
  STATUS: "Status",
  BRANCH: "Branch",
  CREDIT: "Credit",
  FAILED: "Failed",
  ACTION: "Action",
  DENIED: "Denied",
  LATEST: "Latest",
  LABELS: "Labels",
  REMOVE: "Remove",
  FRIDAY: "Friday",
  COLUMN: "Column",
  DETAIL: "Detail",
  SHOW_TAGS: "Show",
  HISTORY: "History",
  ON_DATE: "On date",
  DEVICES: "Devices",
  DISABLE: "Disable",
  MINIMUM: "Minimum",
  MAXIMUM: "Maximum",
  DEFAULT: "Default",
  BALANCE: "Balance",
  CREATED: "Created",
  PENDING: "Pending",
  ARCHIVE: "Archive",
  PROCEED: "Proceed",
  REFRESH: "Refresh",
  TUESDAY: "Tuesday",
  DECLINE: "Decline",
  CONFIRM: "Confirm",
  USER_ID: "User ID",
  DISCARD: "Discard",
  ABANDON: "Abandon",
  PREVIEW: "Preview",
  APPROVE: "Approve",
  ADDRESS: "Address",
  DETAILS: "Details",
  PAY_NOW: "Pay now",
  AUTOPAY: "Autopay",
  BROWSER: "Browser",
  SORT_BY: "Sort by",
  PROFILE: "Profile",
  BLOCKED: "Blocked",
  ENCRYPT: "Encrypt",
  REDACTED: "Redacted",
  ESTD_ON: "Estd. on",
  ARCHIVED: "Archived",
  DISTRICT: "District",
  RECREATE: "Recreate",
  ENTITIES: "Entities",
  BILLIONS: "Billions",
  SUBTOTAL: "Subtotal",
  DOWNLOAD: "Download",
  ACCOUNTS: "Accounts",
  MILLIONS: "Millions",
  VIEW_ALL: "View all",
  VERIFIED: "Verified",
  COMPLETE: "Complete",
  SELECTED: "Selected",
  EMAIL_ID: "Email ID",
  CATEGORY: "Category",
  END_DATE: "End date",
  CALENDAR: "Calendar",
  PREVIOUS: "Previous",
  INACTIVE: "Inactive",
  REVERSED: "Reversed",
  APPROVED: "Approved",
  SERVICES: "Services",
  SET_TOTP: "Set totp",
  QUANTITY: "Quantity",
  FEATURES: "Features",
  INTERNAL: "Internal",
  GENERATE: "Generate",
  DUE_DATE: "Due date",
  PLATFORM: "Platform",
  PER_PAGE: "Per page",
  SCHEDULE: "Schedule",
  SHARE_AS: "Share as",
  PRE_PAID: "Pre paid",
  REJECTED: "Rejected",
  SETTINGS: "Settings",
  IN_WORDS: " In words",
  SETUP_BYOK: "Set byok",
  ADD_FIELD: "Add field",
  DIRECTORS: "Directors",
  FREQUENCY: "Frequency",
  REMINDERS: "Reminders",
  BANK_NAME: "Bank name",
  SETTLE_ID: "Settle ID",
  DASHBOARD: "Dashboard",
  LAST_NAME: "Last name",
  NARRATION: "Narration",
  FULL_NAME: "Full name",
  ENTITY_ID: "Entity ID",
  TIME_SLOT: "Time slot",
  UNARCHIVE: "Unarchive",
  SET_RANGE: "Set range",
  EDIT_LIST: "Edit list",
  IFSC_CODE: "IFSC code",
  INITIATED: "Initiated",
  ABANDONED: "Abandoned",
  PAN_IT_NO: "PAN/IT No",
  NOT_GIVEN: "Not given",
  APPROVALS: "Approval/s",
  FAVOURITES: "Favourites",
  ACCOUNT_ID: "Account ID",
  DIN_NUMBER: "DIN number",
  STATISTICS: "Statistics",
  CIN_NUMBER: "CIN number",
  CATEGORIES: "Categories",
  FETCH_KEYS: "Fetch keys",
  CHANGE_KEY: "Change key",
  VALUE_DATE: "Value date",
  REJECT_ALL: "Reject all",
  SHARE_WITH: "Share with",
  IDLE_FUNDS: "Idle funds",
  ADD_BILLER: "Add biller",
  DATE_RANGE: "Date range",
  OCCURRENCE: "Occurrence",
  LEGAL_NAME: "Legal name",
  LABELS_NEW: "Labels new",
  SELECT_ALL: "Select all",
  START_DATE: "Start date",
  UTR_NUMBER: "UTR number",
  PAN_NUMBER: "PAN number",
  SETTLED_ON: "Settled on",
  CREATED_ON: "Created on",
  CREATED_BY: "Created by",
  TAX_AMOUNT: "Tax amount",
  TIME_SAVED: "Time saved",
  GST_NUMBER: "GST number",
  MIS_REPORT: "MIS report",
  SSO_REGION: "SSO region",
  ENTER_TEXT: "Enter text",
  ADD_OPTION: "Add option",
  MY_PROFILE: "My Profile",
  INVOICE_NO: "Invoice No.",
  SEARCH_BANK: "Search bank",
  BENEFICIARY: "Beneficiary",
  ASSIGN_TAGS: "Assign tags",
  REJECTED_ON: "Rejected on",
  REJECTED_BY: "Rejected by",
  FETCH_BILLS: "Fetch bills",
  RULE_PASSED: "Rule Passed",
  FILE_NUMBER: "File number",
  FILE_STATUS: "File status",
  GST_DETAILs: "GST details",
  PAN_DETAILs: "PAN details",
  BILL_AMOUNT: "Bill amount",
  SEARCH_TAGS: "Search tags",
  GST_DETAILS: "GST Details",
  DESCRIPTION: "Description",
  ATTACHMENTS: "Attachments",
  VERIFY_CODE: "Verify code",
  DIN_DETAILS: "DIN details",
  NATIONALITY: "Nationality",
  TRANSACTION: "Transaction",
  TOTAL_USERS: "Total users",
  APPROVED_BY: "Approved by",
  APPROVED_ON: "Approved on",
  SELECT_USER: "Select User",
  UPLOADED_BY: "Uploaded by",
  SELECT_TYPE: "Select type",
  APP_DETAILS: "App Details",
  SDK_VERSION: "Sdk version",
  ENABLE_TOTP: "Enable TOTP",
  CIN_DETAILS: "CIN details",
  CUSTOM_NAME: "Custom Name",
  CREATED_VIA: "Created via",
  ENTITY_NAME: "Entity name",
  LAST_7_DAYS: "Last 7 days",
  OCCURRENCES: "Occurrences",
  SWAP_ENTITY: "Swap entity",
  SELECT_TAGS: "Select tags",
  BANK_REMARK: "Bank Remark",
  FILTERED_BY: "Filtered by",
  ASSIGN_TAG: "Assign Tag/s",
  AMOUNT_IN_WORDS: "In words",
  RATE_PER_AC: "Rate per A/C",
  ADD_CATEGORY_FIELD: "Field",
  CONFIDENTIAL: "Confidential",
  DELETE_FIELD: "Delete field",
  ADD_CATEGORY: "Add category",
  SEARCH_LABEL: "Search Label",
  TOTAL_ACTUAL: "Total actual",
  BANK_DETAILS: "Bank Details",
  RESUME_SETUP: "Resume setup",
  NOT_VERIFIED: "Not verified",
  MANUFACTURER: "Manufacturer",
  COPY_PASSKEY: "Copy passkey",
  ENCRYPT_DATA: "Encrypt Data",
  MORE_ACTIONS: "More actions",
  ADD_ENTITIES: "Add entities",
  VIEW_ACCOUNT: "View account",
  EDIT_ACCOUNT: "Edit account",
  COMPANY_NAME: "Company name",
  MORE_DETAILS: "More details",
  INITIATED_BY: "Initiated by",
  PERSONALIZED: "Personalized",
  VIEW_DETAILS: "View details",
  EDIT_PROFILE: "Edit Profile",
  GENERATED_ON: "Generated on",
  LAST_28_DAYS: "Last 28 days",
  SELECT_ORDER: "Select order",
  ACCOUNT_TYPE: "Account type",
  TOTAL_AMOUNT: "Total amount",
  LAST_USED_AT: "Last used at",
  LOGGED_IN_BY: "Logged in by",
  AMOUNT_RANGE: "Amount range",
  LOGIN_STATUS: "Login status",
  DEBIT_AMOUNT: "Debit amount",
  LAST_BS_DATE: "Last BS date",
  ASSIGN_LABEL: "Assign label",
  BILL_DETAILS: "Bill Details",
  DELETE_SETUP: "Delete Setup",
  VERIFICATION: "VERIFICATION",
  ACCOUNT_NAME: "Account name",
  BILL_MESSAGE: "Bill message",
  NEW_PASSWORD: "New password",
  ANNOUNCEMENTS: "Announcements",
  CUSTOM_AMOUNT: "Custom amount",
  ERROR_DETAILS: "Error details",
  FETCH_DETAILS: "Fetch Details",
  SCHEDULE_NAME: "Schedule name",
  EXISTING_TAGS: "Existing tags",
  START_PROCESS: "Start process",
  TAGS_SELECTED: "Tags selected",
  CHANGE_KEY_ID: "Change key ID",
  LAST_AGM_DATE: "Last AGM date",
  VERIFY_DEVICE: "Verify device",
  DIRECTOR_NAME: "Director name",
  SELECT_LABELS: "Select Labels",
  FILTER_FIELDS: "Filter fields",
  OWNER_DETAILS: "Owner Details",
  ASSIGNED_TAGS: "Assigned tags",
  ASSIGN_LABELS: "Assign labels",
  CREDIT_AMOUNT: "Credit amount",
  BILL_PROVIDER: "Bill provider",
  EDIT_CATEGORY: "Edit category",
  CHOOSE_COLOR: "Choose a color",
  CATEGORY_NAME: "Category Name",
  CUSTOMER_NAME: "Customer name",
  MOBILE_NUMBER: "Mobile number",
  ACTUAL_INCOME: "Actual income",
  TOKEN_DETAILS: "Token details",
  DELETE_BILLER: "Delete biller",
  TOTAL_BALANCE: "Total balance",
  DELETE_DEVICE: "Delete device",
  TOTAL_ENTRIES: "Total entries",
  DATE_AND_TIME: "Date and time",
  NOT_AVAILABLE: "Not available",
  BILL_DUE_DATE: "Bill due date",
  FETCHED_BILLS: "Fetched bills",
  TAXPAYER_TYPE: "Taxpayer type",
  LOGIN_DETAILS: "Login Details",
  VIEW_SCHEDULE: "View schedule",
  DEBIT_VOUCHER: "Debit voucher",
  SELECTED_USER: "Selected user",
  SWITCH_ENTITY: "Switch entity",
  ERROR_MESSAGE: "Error message",
  TOTAL_TXN: "Total transactions",
  NO_DATA_FOUND: "No data found.",
  HOME_DASHBOARD: "Home dashboard",
  SELECT_COLUMNS: "Select columns",
  FILTER_COLUMNS: "Filter columns",
  VIEW_SCHEDULES: "View schedules",
  PAYMENT_ADVICE: "Payment advice",
  GENERATE_TOKEN: "Generate token",
  AWAITING_FUNDS: "Awaiting funds",
  OTHER_PROFILES: "Other profiles",
  ASSOCIATED_PAN: "Associated PAN",
  HOW_BYOK_WORKS: "How BYOK works",
  OWNER_ACCOUNTS: "Owner Accounts",
  SOURCE_ACCOUNT: "Source account",
  ACCOUNT_ACTION: "Account Action",
  PAYMENT_METHOD: "Payment method",
  TRANSACTION_ID: "Transaction ID",
  CREATE_ACCOUNT: "Create Account",
  AMOUNT_DEBITED: "Amount debited",
  INVOICE_NUMBER: "Invoice number",
  PAYMENT_CHARGE: "Payment charge",
  TOTAL_ACCOUNTS: "Total accounts",
  ORIGIN_DETAILS: "Origin Details",
  COMPANY_STATUS: "Company status",
  CONTACT_NUMBER: "Contact number",
  ADD_ICON_STATS: "Add statistics",
  SELECT_TO_DATE: "Select to date",
  ACCOUNT_STATUS: "Account status",
  TYPE_OF_AMOUNT: "Type of Amount",
  LINKED_AWS_KEY: "Linked AWS key",
  TOTAL_ENTITIES: "Total entities",
  SALARY_PAYMENT: "Salary payment",
  SELECT_COLUMN: "Select Column/s",
  ACCOUNT_NUMBER: "Account number",
  NO_BILLS_FOUND: "No bills found.",
  NO_USERS_FOUND: "No users found.",
  CATEGORY_FIELD_NAME: "Field name",
  CATEGORY_FIELD_TYPE: "Field type",
  FETCHED_KEY_IDS: "Fetched Key IDs",
  SECURITY_CENTER: "Security center",
  ADD_NEW_ACCOUNT: "Add new account",
  CATEGORY_STATUS: "Category status",
  MANDATORY_FIELD: "Mandatory field",
  SELECT_TIMESLOT: "Select time slot",
  MINIMUM_BALANCE: "Minimum balance",
  BILLER_CATEGORY: "Biller category",
  ACTUAL_CASHFLOW: "Actual cashflow",
  TOTAL_PROJECTED: "Total projected",
  TRANSFER_AMOUNT: "Transfer amount",
  SELECT_DUE_DATE: "Select due date",
  SELECT_CATEGORY: "Select category",
  BILLING_HISTORY: "Billing history",
  SOURCE_ACCOUNT_SHORT: "Source A/C",
  BRANCH_LOCATION: "Branch location",
  BILLER_NICKNAME: "Biller Nickname",
  CLOSING_BALANCE: "Closing balance",
  PAYMENT_DETAILS: "Payment details",
  SET_AS_FAVORITE: "Set as favourite",
  CONSUMER_NUMBER: "Consumer number",
  REMOVE_FAVORITE: "Remove favourite",
  DEVICE_PRIORITY: "Device priority",
  BALANCE_SUMMARY: "Balance summary",
  CREATE_SCHEDULE: "Create schedule",
  PAID_UP_CAPITAL: "Paid up capital",
  CAPITAL_DETAILS: "Capital Details",
  COMPANY_DETAILS: "Company Details",
  ADDRESS_DETAILS: "Address Details",
  CHANGE_PASSWORD: "Change password",
  AMOUNT_IN_LAKHS: "Amount in lakhs",
  ENTITY_EMAIL_ID: "Entity email ID",
  APPROVE_ACCOUNT: "Approve account",
  LABELS_SELECTED: "Labels selected",
  EXISTING_LABELS: "Existing labels",
  ARCHIVE_ACCOUNT: "Archive account",
  BALANCE_UPDATED: "Balance updated",
  ASSOCIATED_Bank: "Associated Bank",
  SEND_MIS_REPORT: "Send MIS Report",
  PAY_BENEFICIARY: "Pay Beneficiary",
  REJECT_ACCOUNTS: "Reject accounts",
  CONTACT_DETAILS: "Contact Details",
  ACCOUNT_DETAILS: "Account Details",
  ASSIGNING_LABEL: "Assigning label",
  ASSOCIATED_GSTS: "Associated GSTs",
  LABELS_ASSIGNED: "Labels assigned",
  BENEFITS_TITLE: "Benefits of BYOK",
  ORIGIN_TIMELINE: "Origin Timeline",
  GSTIN_OPTIONAL: "GSTIN (Optional)",
  AMOUNT_CREDITED: "Amount credited",
  BYOK_ENCRYPTION: "BYOK Encryption",
  ENTERPRISE_DATA: "ENTERPRISE DATA",
  APPROVAL_STATUS: "Approval status",
  INCLUDE_EXCLUDE: "Include/ exclude",
  MULTI_OCCURRENCE: "Multi occurence",
  REQUIRE_APPROVAL: "Require approval",
  PENDING_ACCOUNTS: "Pending accounts",
  SERVICE_PROVIDER: "Service Provider",
  BLOCKED_ACCOUNTS: "Blocked Accounts",
  SCHEDULE_HISTORY: "Schedule history",
  CLASS_OF_COMPANY: "Class of company",
  SET_NEW_PASSWORD: "Set new password",
  CONFIRM_PASSWORD: "Confirm password",
  CURRENT_PASSWORD: "Current password",
  DISCARD_SCHEDULE: "Discard schedule",
  CIN_VERIFICATION: "CIN Verification",
  TRANSFER_DETAILS: "Transfer Details",
  SCHEDULE_DETAILS: "Schedule Details",
  SELECT_FREQUENCY: "Select frequency",
  APPROVAL_HISTORY: "Approval history",
  REQUIRED_BALANCE: "Required balance",
  DIN_VERIFICATION: "DIN Verification",
  PAN_VERIFICATION: "PAN Verification",
  APP_VERSION_CODE: "App version code",
  APP_VERSION_NAME: "App version name",
  GST_VERIFICATION: "GST Verification",
  ABSOLUTE_AMOUNT: "Absolute (amount)",
  VIEW_TRANSACTION: "View Transaction",
  TRANSACTION_TYPE: "Transaction type",
  OWNER_ACCOUNT_ID: "Owner account ID",
  OPERATING_SYSTEM: "Operating system",
  CONFIRM_DOWNLOAD: "Confirm Download",
  ADDITIONAL_RECIPIENTS: "Recipients",
  SELECT_FROM_DATE: "Select from date",
  VERIFY_EMAIL_ID: "Verify email - ID",
  SELECT_AN_OPTION: "Select an option",
  REJECT_SCHEDULED: "Reject scheduled",
  CLEAR_PARAMETERS: "Clear parameters",
  STATEMENT_SOURCE: "Statement source",
  RECIPIENTS_ADDED: "Recipients added",
  REQUIRED_DETAILS: "Required Details",
  TOTAL_IDLE_FUNDS: "Total idle funds",
  BENEFICIARY_NAME: "Beneficiary name",
  SINGLE_OCCURRENCE: "Single occurence",
  RECREATE_TRNX: "Recreate Transaction",
  NO_TAGS_ASSIGNED: "No tags assigned.",
  SELECTED_CATEGORY: "Selected category",
  OD_INTEREST_SAVED: "OD interest saved",
  CONNECTED_BANKING: "Connected banking",
  APPROVE_SCHEDULES: "Approve schedules",
  SORT_BY_OPTIONAL: "Sort by (optional)",
  CATEGORY_SELECTED: "Category selected",
  BILL_GENERATED_ON: "Bill generated on",
  IFSC_VERIFICATION: "IFSC Verification",
  PREVIOUS_APPROVER: "Previous approver",
  ENTITIES_SELECTED: "Entities selected",
  OPEN_IN_FULL_VIEW: "Open in full view",
  FETCHED_FROM_BANK: "Fetched from bank",
  ADDITIONAL_FIELDS: "Additional fields",
  STAGE_1_APPROVAL: "Stage 1 - Approval",
  ACCOUNTS_SELECTED: "Accounts selected",
  REJECTED_ACCOUNTS: "Rejected accounts",
  REJECT_REASON_LABEL: "Rejected reason",
  VERIFIED_EMAIL_ID: "Verify email - ID",
  APPROVAL_STATUSES: "Approval statuses",
  LAST_LOGGED_IN_AT: "Last logged in at",
  UPDATE_CREDENTIAL: "Update credential",
  CUSTOM_CATEGORIES: "Custom categories",
  ACTIVATE_CATEGORY: "Activate category",
  AWS_SESSION_TOKEN: "AWS session token",
  AWS_ACCESS_KEY_ID: "AWS access key ID",
  UPLOADED_MANUALLY: "Uploaded manually",
  SCHEDULE_TIMELINE: "Schedule timeline",
  PERMANENT_ADDRESS: "Permanent address",
  UNARCHIVE_ACCOUNT: "Unarchive Account",
  HIDE_CONFIDENTIAL: "Hide confidential",
  SCHEDULE_END_DATE: "Schedule end date",
  CORPORATE_ADDRESS: "Corporate Address",
  ENTER_PAN_DETAILS: "Enter PAN Details",
  BANK_REFERENCE_NO: "Bank reference no.",
  ARCHIVEED_ACCOUNTS: "Archived accounts",
  TYPE_OF_OCCURRENCE: "Type of occurence",
  ASSIGNED_LABELS: "Labels",
  PENDING_APPROVALS: "Pending Approval/s",
  NO_LABELS_ASSIGNED: "No labels assigned",
  INVESTMENT_SCHEMES: "Investment schemes",
  DEFAULT_CATEGORIES: "Default categories",
  DOWNLOAD_STATEMENT: "Download statement",
  BILL_NOT_AVAILABLE: "Bill not available",
  BYOK_TITLE: "Secure Your Data With BYOK",
  ADDITIONAL_DETAILS: "Additional details",
  ENTER_BANK_DETAILS: "Enter Bank details",
  AMOUNT_IN_MILLIONS: "Amount in millions",
  AUTHORIZED_CAPITAL: "Authorized capital",
  CONFIRM_AND_CREATE: "Confirm and create",
  SET_PRIMARY_DEVICE: "Set primary device",
  TRANSACTION_STATUS: "Transaction status",
  AUTHORIZED_DEVICES: "Authorized devices",
  TRANSACTIONS_COUNT: "Transactions count",
  FORGOT_PASSWORD: "Forgot your password?",
  AMOUNT_IN_BILLIONS: "Amount in billions",
  CREATE_TRANSACTION: "Create transaction",
  TRANSACTION_AMOUNT: "Transaction amount",
  POST_UPLOAD_STATUS: "Post upload status",
  CREATE_NEW_ACCOUNT: "Create new account",
  PROJECTED_CASHFLOW: "Projected cashflow",
  SETTLEMENT_DETAILS: "Settlement Details",
  TOGGLE_DESCRIPTION: "Toggle description",
  TRANSACTION_FAILED: "Transaction failed.",
  TAG_TOTAL_SELECTED: "Total tags selected",
  FILTER_BY_OPTIONAL: "Filter by (optional)",
  BANK_ACCOUNT_NUMBER: "Bank account number",
  SEND_FOR_RECREATION: "Send for recreation",
  TRANSACTION_DETAILS: "Transaction details",
  SET_MINIMUM_BALANCE: "Set minimum balance",
  CONSEQUENCES_TITLE: "Consequences of BYOK",
  UPCOMING_HOLIDAY: "Upcoming Bank Holidays",
  SUPPORT_INFORMATION: "Support Information",
  ASSIGNED_CATEGORIES: "Assigned categories",
  AUTHENTICATION_CODE: "Authentication Code",
  SCHEDULE_START_DATE: "Schedule start date",
  ASSOCIATED_ACCOUNTS: "Associated accounts",
  DISTRIBUTION_DENIED: "Distribution denied",
  SERVICE_DESCRIPTION: "Service description",
  DISTRIBUTION_FAILED: "Distribution failed",
  DESTINATION_ACCOUNT: "Destination account",
  DISTRIBUTION_STATUS: "Distribution status",
  TRANSACTION_HISTORY: "Transaction history",
  TOTAL_MISSED_INCOME: "Total missed income",
  TOTAL_ACTUAL_INCOME: "Total actual income",
  DISTRIBUTION_REMARK: "Distribution remark",
  PENDING_TRANSACTION: "Pending transaction",
  AI_SUGGESTED_LABELS: "AI suggested labels",
  BANKING_CREDENTIALS: "Banking credentials",
  DEACTIVATE_CATEGORY: "Deactivate category",
  SOURCE_ACCOUNT_CAPITALIZE: "Source Account",
  DEACTIVATE_CATEGORY_POPUP_SUB_POINTS_1:
    "The category will no longer be active.",
  SELECT_CATEGORY_ICON: "Select Category Icon",
  OTHER_EXISTING_BENEFICIARY_ACCOUNTS_FOUND:
    "Other existing beneficiary accounts found",
  OTHER_EXISTING_TAX_ACCOUNTS_FOUND: "Other existing tax accounts found",
  DEACTIVATE_THIS_CATEGORY_MESSAGE:
    "Deactivate this category in order to edit.",
  MULTI_SELECT_DROPDOWN: "Multi select dropdown",
  AWS_SECRET_ACCESS_KEY: "AWS secret access key",
  SINGLE_SELECT_DROPDOWN: "Single select dropdown",
  BYOK_INFO_MESSAGE: "What BYOK is and how it works.",
  ACTIVATE_CATEGORY_POPUP_MAIN_MESSAGE:
    "Are you sure you want to activate this category?",
  CONFIRM_PROCEED_PLACEHOLDER: "Yes, proceed",
  ENTER_IFSC_CODE: "Enter 10 digit IFSC code",
  OCCURRENCES_TIMELINE: "Occurrence/s timeline",
  NO_LABELS_FOUND: "No existing labels found.",
  SELECT_OWNER_ACCOUNT: "Select owner account",
  BALANCE_DECREASED_BY: "Balance decreased by",
  PENDING_TRANSACTIONS: "Pending transactions",
  FEATURE_NOT_ASSIGNED: "Feature not assigned",
  BENEFICIARY_CATEGORY: "Beneficiary Category",
  CONFIRM_AND_GENERATE: "Confirm and generate",
  ASSIGN_TAGS_TO_USERS: "Assign tags to users",
  SELECT_BILL_CATEGORY: "Select bill category",
  FAILED_TO_DISTRIBUTE: "Failed to distribute",
  TOTAL_DEBITED_AMOUNT: "Total debited amount",
  SELECT_BILL_PROVIDER: "Select bill provider",
  POST_APPROVAL_STATUS: "Post approval status",
  ACCOUNT_HOLDER_NAME: "Account holder's name",
  CASH_COVERAGE_PERIOD: "Cash coverage period",
  BALANCE_INCREASED_BY: "Balance increased by",
  SCHEDULE_TRANSACTION: "Schedule transaction",
  SELECT_FIELD_DETAILS: "Select field details",
  CONFIDENTIAL_HISTORY: "Confidential history",
  TRANSACTION_CATEGORY: "Transaction Category",
  PRODUCTIVITY_TRACKER: "Productivity tracker",
  APPROVED_TRANSACTION: "Approved transaction",
  DISTRIBUTION_CREATED: "Distribution created",
  DISTRIBUTION_PENDING: "Distribution pending",
  CREATE_TRANSACTION_ALT: "Create transaction",
  TRANSACTION_TIMELINE: "Transaction Timeline",
  ASSIGN_UNASSIGN_TAGS: "Assign/Unassign tags",
  SELECT_ALL_LIMITED: "Select all (Maximum 20)",
  SEARCH_BY_INVOICE_NO: "Search by Invoice no.",
  UNSAFE_TO_PROCEED: "It is unsafe to proceed.",
  ENCRYPTION_FAILED: "BYOK encryption - Failed",
  ENTER_TRANSFER_AMOUNT: "Enter transfer amount",
  STAGE_2_DISTRIBUTION: "Stage 2 - Distribution",
  SOURCE_ACCOUNT_NUMBER: "Source account number",
  SELECT_PAYMENT_METHOD: "Select Payment Method",
  DISTRIBUTION_APPROVED: "Distribution approved",
  DISTRIBUTION_COMPLETE: "Distribution complete",
  DISTRIBUTION_REJECTED: "Distribution rejected",
  FILE_NUMBER_OPTIONAL: "File number (optional)",
  SELECT_OWNER_ACCOUNTS: "Select owner accounts",
  OWNER_ACCOUNT_DETAILS: "Owner account details",
  APPROVED_TRANSACTIONS: "Approved transactions",
  API_ERROR_HINT: "API error message will show.",
  REGISTER_NEW_ACCOUNT: "Register a new account",
  EDIT_INTERNAL_ACCOUNT: "Edit Internal Account",
  VERIFY_AUTH_CODE: "Verify authentication code",
  TOTP_ENABLED_SUCCESS: "TOTP has been enabled.",
  UNASSIGNED_CATEGORIES: "Unassigned categories",
  VERIFY_CONTACT_NUMBER: "Verify contact number",
  TOTAL_CURRENT_BALANCE: "Total current balance",
  GENERATE_NEW_PASSWORD: "Generate new password",
  UPLOAD_BANK_STATEMENT: "Upload Bank Statement",
  ENTER_CONTACT_DETAILS: "Enter contact details",
  RECREATE_TRANSACTIONS: "Recreate transactions",
  TOTAL_AMOUNT_IN_WORDS: "Total amount In words",
  IMPORTANT_TRANSACTION: "Important Transaction",
  BALANCE_TRANSFER_TYPE: "Balance transfer type",
  POST_APPROVAL_PROCESS: "Post Approval Process",
  DISTRIBUTION_REVERSAL: "Distribution reversal",
  ENTER_AWS_CREDENTIALS: "Enter AWS Credentials",
  SEARCH_OR_ENTER_NEW_TAG: "Search/Enter new tag",
  FIRST_OCCURRENCES_DATE: "First occurrence date",
  FAILED_TO_TAKE_ACTION: "Failed to take action!",
  NO_ASSOCIATED_GSTS: "No associated GSTs found.",
  DISTRIBUTION_ABANDONED: "Distribution abandoned",
  TNX_SUBHEADING: "Create an incoming transaction",
  SELECT_TRANSFER_AMOUNT: "Select transfer amount",
  MODEL_TERMS_OF_PAYMENT: "Model/Terms of Payment",
  APPROVE_MORE_SCHEDULES: "Approve more schedules",
  CONFIRM_KNOWLEDGE: "Confirm your BYOK knowledge",
  PAN_LINKED_WITH_AADHAR: "PAN linked with aadhar",
  LOGOUT_OF_ALL_ACCOUNTS: "Logout of all accounts",
  BENEFICIARY_ACCOUNT_ID: "Beneficiary account ID",
  SOURCE_ACCOUNT_DETAILS: "Source Account Details",
  DISTRIBUTION_INITIATED: "Distribution initiated",
  SELECT_SECURITY_SERVER: "Select security server",
  STANDARD_LABELS: "standard premium deluxe basic",
  VIEW_ACCOUNT_STATEMENT: "View account statement",
  SHOW_ONLY_CONFIDENTIAL: "Show only confidential",
  USER_WITH_ADMIN_RIGHTS: "User with admin rights",
  FEATURE_RESOLUTION_NOTE: "To resolve this issue",
  UTILITY_ACCOUNT_NUMBER: "Utility account number",
  TRANSACTION_DATETIME: "Transaction date and time",
  VENDOR_ACCOUNT_ACTION: "Action on vendor account",
  DASHBOARD_TITLE: "Recreate Transaction Dashboard",
  SEARCH_OR_ENTER_LABEL: "Search / enter new label",
  CIN_DATA_NOT_AVAILABLE: "CIN data not available.",
  SELECTED_TRANSACTION_COUNT: "Selected Transaction",
  ASSIGN_TAGS_TO_ACCOUNTS: "Assign tags to accounts",
  FETCH_TEXT_API_RESPONSE: "Fetch text API response",
  SEARCH_ENTITY: "Search by name/address/PAN number",
  SELECT_USERS_TO_APPROVE: "Select users to approve",
  SUCCESSFUL_TRANSACTIONS: "Successful transactions",
  AMOUNT_DEBITED_DAY_WISE: "Amount debited day wise",
  MISSED_POTENTIAL_INCOME: "Missed potential income",
  DISTRIBUTION_STATISTICS: "Distribution statistics",
  GST_DETAILS_ACCOUNT: "Beneficiary's GSTIN Details",
  AUTOFILL_PAN_LEGAL_NAME: "Autofill PAN Legal Name",
  SOURCE_ACCOUNT_BREAKDOWN: "Source account balance",
  BANK_DETAILS_ACCOUNT: "Beneficiary's Bank Details",
  TOTAL_TIME_WITH_XPENTRA: "Total time with Xpentra",
  CREATE_BULK_TRANSACTION: "Create bulk transaction",
  SELECT_INTERNAL_ACCOUNT: "Select internal account",
  ASSIGN_LABELS_OPTIONAL: "Assign Labels (optional)",
  CANNOT_APPROVE_TRANSACTION: "Approval not possible",
  I_HAVE_DOWNLOADED_APP: "I have downloaded the app.",
  ACCOUNT_APPROVED: "This account has been approved.",
  DESTINATION_ACCOUNT_NAME: "Destination account name",
  ACTION_ON_VENDOR_ACCOUNT: "Action on vendor account",
  ANNUAL_COMPLIANCE_STATUS: "Annual Compliance Status",
  MAINTAIN_MINIMUM_BALANCE: "Maintain minimum balance",
  BENEFICIARY_PAN_DETAILS: "Beneficiary's PAN Details",
  CONFIDENTIAL_TRANSACTION: "Confidential transaction",
  BANK_ACCOUNT_HOLDER_NAME: "Bank account holder name",
  MODE_TERMS_OF_PAYMENT_LABEL: "Mode/Terms of Payment",
  FILTER_COLUMNS_OPTIONAL: "Filter columns (optional)",
  INVOICE_NUMBER_IN_USE_LABEL: "Invoice number in use",
  BENEFICIARY_TRANSACTIONS: "Beneficiary transactions",
  ACCOUNT_APPROVAL_PENDING: "Account approval pending",
  ENTER_ADDITIONAL_DETAILS: "Enter additional details",
  EDIT_BENEFICIARY_ACCOUNT: "Edit Beneficiary Account",
  INCORRECT_ACCOUNT_NUMBER: "Incorrect account number",
  FURTHER_APPROVAL_PENDING: "Further approval pending",
  ENTER_TRANSACTION_AMOUNT: "Enter transaction amount",
  VIEW_INSTANTPAY_BALANCE: "To view InstantPay balance",
  DESTINATION_ACCOUNT_CAPITALIZE: "Destination Account",
  LOGIN_IAM_HINT: "Login to the IAM user > Access keys",
  SCHEDULE_APPROVED: "This schedule has been approved.",
  WARNING_OR_ERROR_MESSAGES: "Warning / Error Messages",
  SELECT_EXISTING_ACCOUNT: "Select an existing account",
  ACCOUNT_NAME_LEGAL: "Account name - Using legal name",
  WANT_TO_ADD_MORE_DEVICES: "Want to add more devices ?",
  SCHEDULE_CREATION_FAILED: "Failed to create schedule.",
  DELETE_SETUP_ACTION_WARNING:
    "This action is permanent and cannot be reversed.",
  RETRIEVE_KEY: "Retrieve the key credentials from AWS",
  ENCRYPTION_IN_PROCESS: "BYOK Encryption - In Process",
  SELECT_ACTION_RADIO: "Select an action (radio button)",
  VIEW_LINKED_OWNER_ACCOUNT: "View linked owner account",
  AMOUNT_FILTER_NOTE: "Specify the amount to filter by.",
  UNSUCCESSFUL_TRANSACTIONS: "Unsuccessful transactions",
  INITIATE_INTERNAL_TXN: "Initiate internal transaction",
  SCHEDULED_TRANSFER_MATRIX: "Scheduled transfer matrix",
  TRANSACTION_APPROVED: "Transaction have been approved",
  ASSOCIATED_ACCOUNTS_FOUND: "Associated accounts found",
  APPROVE_CREATE_TRNX: "Approve the created transaction",
  SCHEDULE_APPROVAL_PROCESS: "Schedule Approval Process",
  RECREATE_THIS_TRANSACTION: "Recreate this transaction",
  SELECT_BANK_TO_FETCH_IFSC: "Select bank to fetch IFSC",
  CONTINUE_WHERE_LEFT_OFF: "Continue where you left off",
  AUTO_TRANSFER_AMOUNT: "Auto transfer a specific amount",
  SELECT_SORT_FIELD: "Select field to sort the report by",
  UPLOAD_STATEMENT_PROMPT: "Proceed to upload statement?",
  SCHEDULE_REJECTION_FAILED: "Schedules rejection failed",
  NO_ROLES_ASSIGNED: "No roles assigned to this account.",
  SELECT_KEY_TO_ENCRYPT: "Select key ID and encrypt data",
  UPSERT_FIELD_FORCE_ACCOUNT: "Upsert Field Force Account",
  TOTAL_TIME_WITHOUT_XPENTRA: "Total time without Xpentra",
  CONFIRM_CLICK_NEXT: "Confirm and click next to proceed.",
  BULK_TRANSACTIONS_VIEW_ALL: "Bulk transactions view all",
  SELECT_BENEFICIARY_ACCOUNT: "Select beneficiary account",
  BENEFICIARY_ACCOUNT_NUMBER: "Beneficiary account number",
  SELECT_ACCOUNTS_TO_PROCEED: "Select Accounts To Proceed",
  MISSED_POTENTIAL_INCOME_STAR: "Missed potential income*",
  CREATE_BENEFICIARY_ACCOUNT: "Create beneficiary account",
  CONTACT_DETAILS_ACCOUNT: "Beneficiary's Contact Details",
  ACCOUNTS_ASSOCIATED_TO_PAN: "Accounts Associated to PAN",
  SELECT_ENTITIES_TO_PROCEED: "Select Entities To Proceed",
  DESTINATION_ACCOUNT_NUMBER: "Destination account number",
  CONFIRM_AND_CREATE_ACCOUNT: "Confirm and create account",
  ASSOCIATED_SCHEDULES_FOUND: "Associated schedules found",
  AMOUNT_CHARGEABLE_IN_WORDS: "Amount chargeable in words",
  SELECT_DESTINATION_ACCOUNT: "Select destination account",
  TRANSACTION_SUBHEADING: "Create an outgoing transaction",
  UNARCHIVE_NOTE: "Note - This account will become active.",
  NO_BENEFICIARY_ACCOUNTS: "No beneficiary accounts found.",
  SESSION_TOKEN_EXPIRES: "Session token expires in 8 hours",
  ARCHIVE_NOTE: "Note - This account will become inactive.",
  NO_ADDITIONAL_RECIPIENTS_ADDED: "No recipients assigned.",
  OPEN_BROWSER_AND_DOWNLOAD: "Open in browser and download",
  SCHEDULE_REJECTED_TEXT: "This schedule has been rejected.",
  DESTINATION_ACCOUNT_DETAILS: "Destination Account Details",
  CREATE_SCHEDULE_TRANSACTION: "Create schedule transaction",
  CROSSCHECK_INFO: "Crosscheck the information given above.",
  SCHEDULE_CREATE_PLACEHOLDER_NAME: "Name (at least 5 char)",
  SCHEDULE_CREATED_SUCCESS: "Schedule created successfully.",
  REPORT_GENERATED_SUCCESS: "Report generated successfully.",
  SELECT_TRANSACTION_PROMPT: "Select Transaction To Proceed",
  VIEW_CONSOLIDATED_STATEMENT: "View consolidated statement",
  PAYMENTS_PROCESSED_DAY_WISE: "Payments processed day wise",
  TRANSACTION_INITIATION_DATE: "Transaction initiation date",
  BENEFICIARY_ACCOUNT_DETAILS: "Beneficiary Account Details",
  SCAN_QR_CODE_AUTH_APP: "Scan QR code on authenticator app",
  CONFIRM_AND_CREATE_SCHEDULE: "Confirm and create schedule",
  TRNX_NOTE: "Transactions listed below are to be executed.",
  DEFAULT_SOURCE_ACCOUNT_CAPITALIZE: "Default Source Account",
  QR_OR_PASSKEY_MANUAL_ENTRY: "Scan QR code or enter passkey",
  TRANSACTION_REJECTED: "This transaction has been rejected!",
  BOTH_PASSWORDS_DO_NOT_MATCH: "Both passwords do not match.",
  NO_ASSOCIATED_ACCOUNT_FOUND: "No associated account found.",
  FIELD_FORCE_ACCOUNT_ACTION: "Action on field force account",
  STATS_PAYMENTS_PROCESSED: "Statistics - Payments processed",
  SELECT_A_DESTINATION_ACCOUNT: "Select a destination account",
  SELECT_REIMBURSEMENT_ACCOUNT: "Select reimbursement account",
  VIEW_LINKED_INTERNAL_ACCOUNT: "View linked internal account",
  SUCCESS_OR_INFO_MESSAGES: "Success / Informational Messages",
  TRANSACTION_REJECTION_FAILED: "Transaction rejection failed",
  CREATE_AS_CONFIDENTIAL: "Create As Confidential Transaction",
  PREVIOUS_APPROVERS_OPTIONAL: "Previous Approvers (optional)",
  BENEFICIARY_CONTACT_DETAILS: "Beneficiary's Contact Details",
  NO_ASSIGNED_CATEGORIES_FOUND: "No assigned categories found",
  NO_SERVICES_ASSIGNED: "No services assigned to this account.",
  NO_FEATURES_ASSIGNED: "No features assigned to this account.",
  LABELS_GENERATED: "Labels generated based on your selection.",
  BENEFICIARY_AND_CATEGORY: "Beneficiary account and category",
  TRANSACTION_CHARGES_NOTE: "Additional charges are applicable",
  TRANSACTION_LIMIT_NOTE: "Maximum transaction limit INR 2 lakhs",
  TWO_FACTOR_ACTIVE: "Two-Factor Authentication is Now Active!",
  ACTIVE_ASSOCIATED_ACCOUNTS: "Active associated accounts",
  NO_DATA_FOUND_FILTER: "No data found for the selected filter.",
  DISABLE_TOTP_CONFIRM: "Are you sure you want to disable TOTP?",
  SELECT_TRANSACTION_TO_PROCEED: "Select Transaction To Proceed",
  ACTION_ON_FIELD_FORCE_ACCOUNT: "Action on field force account",
  ASSOCIATED_TRANSACTIONS_FOUND: "Associated transactions found",
  ASSOCIATED_ACCOUNTS_ARE_FOUND: "Associated accounts are found",
  CONFIRM_KNOWLEDGE_PLACEHOLDER: "I have read & understood BYOK",
  INSTANT_TRANSFER_NOTE: "Instant transfer during banking hours",
  TOTAL_MISSED_POTENTIAL_INCOME: "Total missed potential income",
  NO_ASSOCIATED_ACCOUNTS: "No active associated accounts found.",
  DAILY_BALANCE_SUMMARY: "Daily balance summary of this account",
  STATISTICS_TRANSACTION_COUNT: "Statistics - Transactions count",
  DO_NOT_DELETE_KEY: "Do not delete the key from your AWS server",
  ACCOUNT_COULD_NOT_BE_VERIFIED: "Account could not be verified.",
  MISSED_INCOME_7_DAYS: "Missed potential income for last 7 days",
  UNABLE_TO_GENERATE_QR: "Unable to generate QR code or pass key",
  NO_UNASSIGNED_CATEGORIES_FOUND: "No unassigned categories found",
  SEARCH_USERS: "Search by first name/last name/user ID/full name",
  CREATE_BENEFICIARY_TRANSACTION: "Create beneficiary transaction",
  TRANSACTION_OCCURRENCE_DETAILS: "Transaction Occurrence Details",
  PREDICTED_CASH_COVERAGE_PERIOD: "Predicted cash coverage period",
  SOURCE_AND_DESTINATION_ACCOUNT: "Source and destination account",
  NEFT_TRANSFER_NOTE: "Upto 30 mins transfer during banking hours",
  BENEFICIARY_TRANSACTION_FAILED: "Beneficiary Transaction failed.",
  ARCHIVE_CONFIRM: "Are you sure you want to archive this account?",
  REJECTED_FOR_RECREATION_TITLE: "Rejected and sent for recreation",
  SELECT_OPTION_TO_EDIT: "Select the option you would like to edit",
  CONTINUE_ACCOUNT_CREATION: "Confirm to continue account creation",
  INCORRECT_ACCOUNT_AND_WE_NUMBER: "Incorrect account and we number",
  TRANSACTION_REJECTED_SUCCESS: "Transaction rejected successfully.",
  ASSIGNED_BENEFICIARY_CATEGORIES: "Assigned Beneficiary Categories",
  CREATE_OR_UPDATE_CLIENT_ACCOUNT: "Create Or Update Client Account",
  INTERNAL_TXN_SUCCESS: "Internal transaction settled successfully.",
  TAX_TRANSACTION_CREATION_FAILED: "Tax transaction creation failed.",
  SELF_VERIFY_CAUTION: "Please self verify and proceed with caution.",
  APPROVE_TRNX_NOTE: "Approve the accounts to initiate transactions.",
  VENDOR_PAYMENT_ACTION: "Vendor payment action against owner account",
  NO_TAGS_ASSIGNED_TO_THIS_ACCOUNT: "No tags assigned to this account.",
  CREATE_OR_UPDATE_BENEFICIARY: "Create or update beneficiary account",
  CLICK_FETCH_STATISTICS: "Click below to fetch the updated statistics",
  DELETE_BILLER_CONFIRM: "Are you sure you want to delete this biller?",
  FILE_UPLOAD_ADDITIONAL: "Drag and Drop your file here OR Browse file",
  UNARCHIVE_CONFIRM: "Are you sure you want to unarchive this account?",
  CONFIRM_CHANGE_KEY: "Are you sure you want to change encryption key?",
  LEAVE_PAGE_WARNING_HEADER: "Are you sure you want to leave this page?",
  DATA_AT_HIGH_RISK: "Currently your data is decrypted and at high risk",
  BENEFICIARY_TRANSACTION_DASHBOARD: "Beneficiary transaction dashboard",
  SELECT_APPROVING_USER: "Select user who is approving the transaction.",
  TOGGLE_CONFIDENTIAL_TRANSACTIONS: "Show/hide confidential transactions",
  UNASSIGNED_CATEGORY_NOTE: "To assign an unassigned category click here",
  APPROVAL_STATUS_ACTION: "Approval status action against client account",
  CREATE_ACCOUNT_CONFIRM: "Are you sure you want to create this account?",
  SELECT_SERVICE_PROVIDER: "Select service provider and enter credentials",
  DISCARD_SCHEDULE_CONFIRM: "Are you sure you want discard this schedule?",
  SCHEDULED_TRANSACTIONS_THIS_WEEK: "Scheduled transactions for this week",
  SCHEDULES_REJECTED_SUCCESS: "Schedules have been rejected successfully.",
  MISSED_POTENTIAL_NOTE: "* Amounts rounded off as per banking standards.",
  COPY_FROM_PREVIOUS: "Copy or autofill from previous transactions details",
  CONFIRM_CONTINUE_ACCOUNT_CREATION: "Confirm to continue Account Creation",
  CUSTOM_AMOUNT_WITH_MIN_BALANCE: "Custom amount above set minimum balance",
  REJECT_REASON_PROMPT: "Please state the reason for rejecting the account.",
  TO_ASSIGN_UNASSIGN_CATEGORY: "To assign an unassigned category click here",
  SELECT_PREVIOUS_APPROVERS_OPTIONAL: "Select Previous Approvers (Optional)",
  REJECT_SCHEDULE_CONFIRM: "Are you sure you want to reject this schedules?",
  BENEFIT_FLEXIBILITY: "Flexibility: Easily update or rotate keys as needed.",
  REJECT_REASON_TEXT_ACC: "Please state the reason for rejecting the account.",
  EXIT_CURRENT_FLOW_NOTE: "Leaving this page will exit you from current flow.",
  LABELS_STATS_INFO: "Use labels to filter and analyze your statistical data.",
  TAG_ASSIGN_NEW: "Click on 'Assign new tag' to assign the tag entered above.",
  SELECT_TRANSACTION_AND_AMOUNT: "Select transaction type and enter the amount",
  NO_ACCOUNTS_FOUND: "No accounts found. All biller accounts will appear here.",
  DISTRIBUTION_FAILED_DESC: "The distribution for this transaction has failed.",
  SELECT_FIELD_FORCE_ACCOUNT: "Select field force account",
  SELECT_KEY_ID_TO_ENCRYPT:
    "Select a Key ID from the list below to encrypt the data.",
  SELECT_CREDENTIALS_TO_ENCRYPT:
    "Select the credentials to encrypt data from the selected key.",
  BYOK_PRE_SETUP_NOTE:
    "Before you begin setting up BYOK, we recommend reading the information below to ensure a smooth and secure process.",
  BANKING_CREDENTIALS_ENCRYPTION_NOTE:
    "Note: Only your banking credentials will be encrypted with your key, not the entire system.",
  WHY_BANKING_DATA_RESTRICTED: "Why only banking data?",
  TRANSACTION_EXECUTION_NOTE_INSTANTLY:
    "Transactions executed instantly upon approval",
  BENEFICIARY_TRANSACTION_SETTLED:
    "Beneficiary transaction settled successfully.",
  SELECT_SOURCE_AND_DESTINATION:
    "Select source account and destination account",
  DEACTIVATE_CATEGORY_POPUP_MAIN_MESSAGE:
    "Are you sure you want to deactivate this category?",
  ADDITIONAL_DETAILS_PREVIEW: "Additional Details Preview",
  SELECT_ACCOUNT_TO_VIEW_CONSOLIDATED_STATEMENT:
    "Select account/s to view consolidated statement.",
  RTGS_TRANSACTION_EXECUTION_NOTE:
    "Transactions executed instantly during banking hours",
  RTGS_TRANSACTION_LIMIT_NOTE:
    "Transaction amount should be more than INR 2 lakhs",
  GENERATE_NEW_PASSWORD_CONFIRM:
    "Are you sure you want to generate a new password?",
  I_HAVE_SCANNED_QR_OR_ENTERED_PASSKEY:
    "I have scanned the QR code/entered the passkey.",
  TRANSACTION_EXECUTION_NOTE:
    "Transactions executed every 30 mins upon approval",
  NO_TRANSACTIONS_THIS_WEEK:
    "There are no transactions scheduled for this week.",
  COPY_AWS_FIELDS_INSTRUCTION:
    "Copy required data from the highlighted fields below.",
  INCORRECT_ACCOUNT_TOOLTIP:
    "Incorrect account number. Show tooltip if exceeds.",
  START_END_6_MONTH_LIMIT:
    "Start and end dates must be within a 6-month period.",
  DISTRIBUTION_DENIED_DESC:
    "The distribution for this transaction has been denied.",
  APPROVAL_COMPLETE_NOTE:
    "There are no more accounts that require your approval.",
  BENEFICIARY_TRANSACTION_SUCCESS_APPROVED:
    "Beneficiary transaction has been created and approved.",
  SCHEDULE_NOTE_MIN_LENGTH:
    "Note - The name must consist of at least 5 characters.",
  REJECTION_REASON_PROMPT:
    "Please state the reason for rejecting the transaction.",
  LEAVE_PAGE_WARNING_MSG: "Leaving this page will exit you from current flow.",
  LEAVE_PAGE_WARNING_MSG_EDIT_CONTACT:
    "Leaving this page will not update the changes you made.",
  DISTRIBUTION_REVERSED_DESC:
    "The distribution for this transaction has been reversed.",
  APPROVE_ACCOUNT_TO_INITIATE:
    "Approve the accounts to initiate internal transactions.",
  ACCOUNT_NOT_VERIFIED_VIRTUAL:
    "Account could not be verified as it is a virtual account.",
  UNBLOCK_CONTACT_SUPPORT:
    "To unblock this account, please contact customer support.",
  DISTRIBUTION_ABANDONED_DESC:
    "The distribution for this transaction has been abandoned.",
  REJECTION_REASON_NOTE:
    "Note - The reason must consist of at least 10 characters.",
  SOURCE_ACCOUNT_DES_TEXT:
    "This account will be debited to process the transactions.",
  ACTIVE_ASSOCIATED_ACCOUNTS_FOUND: "Active associated accounts found",
  DELETE_SETUP_CONFIRM: "Are you sure you want to delete setup?",
  NO_TRANSACTIONS_TO_RECREATE:
    "There are no more transactions that require recreation.",
  TRANSACTION_OCCURRENCE_COUNT:
    "Number of transactions generated during the chosen period",
  SELECT_FREQUENCY_OCCURRENCE_NOTE:
    "Number of transactions generated during the chosen period.",
  ERROR_TAKING_ACTION:
    "An error occurred while taking action on this transaction.",
  ASSIGN_TAGS_INSTRUCTION:
    'Select tag(s) and click "Assign" to link them to the user(s).',
  NO_TXNS_REMAINING_FOR_APPROVAL:
    "There are no more transactions that require your approval.",
  LABEL_STATS_ACCOUNTS:
    "Labels will generate statistics for the associated accounts.",
  ALL_BENEFICIARY_TRANSACTIONS:
    "All transactions related to the beneficiary are listed below.",
  CONTACT_APPROVER_NOTE:
    "To approve the account, please contact the authorised person.",
  ACCOUNT_APPROVAL_NOTE:
    "To approve the account, please contact the authorized person.",
  REMOVE_FAVORITE_CONFIRM:
    "Are you sure you want to remove this account from favourites ?",
  SELECT_ACCOUNTS_FOR_CONSOLIDATION:
    "Select up to 10 accounts to view their consolidated statement.",
  ACCOUNT_STATEMENT_NOTE:
    "As on - Statement update depends on availability from the bank",
  MIS_FILTER_NOTE:
    "MIS report will be filtered based on the fields selected below.",
  ADDITIONAL_DETAILS_UNSUPPORTED:
    "Additional details are not supported for the selected category.",
  REJECTED_FOR_RECREATION_DESC:
    "This transaction has been rejected and can now be recreated.",
  BYOK_BENEFITS_INFO:
    "The benefits and consequences of using your own encryption key.",
  CATEGORY_NAME_NOTE: "Note - Category name must be 3-20 characters.",
  DELETE_FIELD_WARNING: "Are you sure you want to delete this field?",
  COMPLETION_TIME_NOTICE: "This will take up to 5 minutes to complete",
  ENTER_CURRENT_PASSWORD_NOTE:
    "Enter current password, then set and confirm your new password.",
  ACCOUNT_CREATED_SUCCESS:
    "Beneficiary account created successfully and awaiting approval.",
  TRANSACTION_APPROVED_FOR_DISTRIBUTION:
    "This transaction has been approved and is set for distribution.",
  BENEFIT_COMPLIANCE:
    "Improved Compliance: Meets security and regulatory requirements.",
  APPROVE_TRNX_FOR_FUND:
    "Approve the transactions for fund transfer between owner account.",
  REFERENCE_IMAGES_NOTE:
    "Note: Reference images of AWS KMS Manager as of February 23,2024.",
  SCHEDULE_BENEFICIARY_NOTE:
    "All scheduled transaction related to beneficiary are listed below.",
  CONTACT_IFSC_CHANGE:
    "Please contact an Xpentra administrator to change the IFSC detail.",
  UNASSIGN_TAGS_INSTRUCTION:
    'Select tag(s) and click "Unassign" to unlink them from the user(s).',
  BENEFICIARY_TRANSACTION_SUCCESS_PENDING:
    "Beneficiary transaction created successfully and awaiting approval.",
  ONLY_ACTIVE_ACCOUNTS_SELECTABLE:
    "Only active (pending & approved) accounts are enabled for selection.",
  SELECT_PREVIOUS_APPROVERS:
    "Select previous approver/s who have already approved the transaction.",
  EXISTING_ACCOUNT_NOTE:
    "The following existing accounts are associated with the PAN provided.",
  APPROVALS_PENDING_FROM_GRADES:
    "Approvals are pending from individual or all of the following grades.",
  FEATURE_MISSING_NOTE:
    "The services required for this feature are not assigned to your user",
  BENEFIT_INTEGRATION:
    "Seamless Integration: Works with your existing key management system.",
  TAG_SELECT_ASSIGN:
    'Select tag(s) and click "Assign" to link them to the owner account(s).',
  SELECT_FIELD_NOTE:
    "Please select the field for which you want to generate the MIS report.",
  LABELS_STATS_USAGE_NOTE:
    "Labels will be used to generate statistics for the associated accounts.",
  DELETE_SETUP_DATA_WARNING: "Your data will get decrypted and unprotected.",
  REJECT_REASON_TEXT_TXN:
    "Rejected reason. Please state the reason for rejecting the transaction.",
  BILL_PROVIDER_SEARCH_HINT:
    "To fetch the provider, enter bill provider name in the search bar above.",
  ACTIVATE_THIS_CATEGORY_MESSAGE: "Activate this category in order to use it.",
  ONLY_CONNECTED_BANKING_NOTE:
    "Only accounts with connected banking active are available for selection.",
  APPROVED_NEEDS_SECOND_APPROVER:
    "It is approved and requires another user's approval before distribution.",
  CREATE_OR_UPDATE_BENEFICIARY_DESCRIPTION:
    "Create or update beneficiary account which allows user to create account.",
  APPROVE_TRNX_BENE:
    "Approve the transactions for fund transfer from owner to the beneficiary.",
  SCHEDULE_INTERNAL_CREATED_AND_APPROVED:
    "Schedule created successfully and internal transaction has been approved.",
  SOURCE_ACCOUNT_USAGE_NOTE:
    "This account will be used to settle this transaction once it is approved.",
  TRANSACTION_ALREADY_APPROVED:
    "This transaction cannot be discerned, since it has been approved already.",
  LABELS_USAGE_NOTE:
    "Labels will be used to generate statistics for the associated transactions.",
  SCHEDULE_BENE_CREATED_AND_APPROVED:
    "Schedule created successfully and beneficiary transaction has been approved.",
  BANK_FILTER_REQUIREMENTS:
    "Note: Account number and IFSC code must be filled to filter by bank details.",
  TAGGED_OWNER_ACCOUNTS_NOTE:
    "Tagged owner accounts will be visible to the users who share the same tags.",
  ACCOUNT_CREDIT_NOTE:
    "The amount will be credited to this account once distribution is completed.",
  TAG_SELECT_UNASSIGN:
    'Select tag(s) and click "Unassign" to unlink them from the owner account(s).',
  ACCOUNT_NOT_APPROVED_NOTE:
    "Account is not approved, please approve account before approving transaction.",
  ACCOUNT_NOT_APPROVED:
    "Account is not approved, please approve account before approving transaction.",
  INVOICE_NUMBER_IN_USE:
    "Looks like this invoice number is already in use for some other transaction/s.",
  NO_PENDING_ACCOUNTS:
    "No pending accounts found. There are no more accounts awaiting your approval.",
  ASSIGN_LABEL_HELP:
    "To assign a label, type a new label name in the search bar and click 'Assign'.",
  IMPS_DISABLED_OR_NONEXISTENT:
    "IMPS may be currently disabled for this account or this account may not exist.",
  MULTIPLE_ENTITIES_LINKED:
    "Multiple entities linked - Select which ones to include in the quick swap tab.",
  LABELS_AUTO_ASSIGNED_NOTE:
    "The labels below are auto assigned as per selected internal and owner accounts.",
  FEATURE_CONTACT_ADMIN:
    "Contact your admin and request them to assign the feature required to your user",
  NO_ACTIVE_ACCOUNTS_FOR_PAN:
    "There are no existing active accounts that are associated with the PAN provided.",
  CONFIRMATION_NOTICE_TEXT:
    "Before proceeding, please confirm that you’ve read and understood the following:",
  DESTINATION_ACCOUNT_DES_TEXT:
    "This account will be credited with the amount once the distribution is completed.",
  AUTO_ASSIGNED_LABELS_NOTE:
    "The labels below are auto assigned as per selected beneficiary and owner account.",
  CHANGE_PASSWORD_NOTE:
    "Note: You will be logged out and asked to log in again after the password change.",
  TAGGED_USER_ACCESS_HINT:
    "Tagged users will gain access to view only owner accounts that share the same tags.",
  BENEFICIARY_TRANSACTION_AUTO_SETTLE_NOTE:
    "It will be auto settled once sufficient balance is available in the source account.",
  CHANGE_KEY_WARNING:
    "Changing key will unlink the existing key and link a new encryption key in its place.",
  SAVE_BACKUP_CODES_WARNING:
    "Ensure you save the backup codes securely. Do not share your backup codes with anyone.",
  TOKEN_EXPIRY_VARIANT:
    "If token expires, you will have to regenerate session token, as it will not fetch keys",
  GST_REPLACE_RULE:
    "GST can only be replaced with other GSTs that are associated with the provided PAN.",
  ENTER_IFSC_INSTRUCTIONS:
    "Select bank or enter 10 digit IFSC code in the search bar, to fetch the IFSC details.",
  SELECT_TRANSACTION_TYPE_TO_FETCH_MATRIX:
    "Select the transaction type to fetch your entity’s authorization matrix configuration.",
  TRANSACTION_APPROVED_PENDING_OTHERS:
    "Transaction has been approved by the selected user but further approvals are pending",
  PAN_GST_EDIT_NOTE:
    "Since GST and PAN are linked, to edit PAN, the associated GST must also be provided.",
  ADD_RECIPIENT_NOTE:
    "Enter the recipient's email ID above and click 'Add' to include them in the list.",
  BENEFIT_ENHANCED_SECURITY:
    "Enhanced Security: Your key stays with you, only you can access your sensitive data.",
  SOURCE_ACCOUNT_DEBIT_NOTE:
    "This account will be debited to process the transaction(s) on the scheduled date(s).",
  ALL_CATEGORIES_ASSIGNED_WARNING:
    "All categories are assigned to this account. Assigning all categories is highly unsafe.",
  TO_ASSIGN_NEW_LABEL:
    "To assign a label, type a new label name in the search bar and click 'Assign new label'.",
  MISSED_NOTE_AVAILABLE_DAYS:
    "Missed potential income is calculated only for the days the bank statement is available.",
  UPLOAD_BANK_STATEMENT_HEADER:
    "Choose the owner account for the statement upload. Ensure it matches the bank statement.",
  REJECT_LINKED_SCHEDULES_NOTE:
    "The following schedules are linked and need to be rejected before rejecting this account.",
  INTEREST_NOTE_CURRENT:
    "This amount is based on the interest that you have earned by auto-investing using Xpentra.",
  WHY_ONLY_BANKING_DATA:
    "Note: Only your banking credentials will be encrypted with your key, not the entire system.",
  LINKED_TXNS_REJECTION_WARNING:
    "The following transactions are linked and need to be rejected before rejecting this account.",
  INVESTMENT_NOTE:
    "Income that could have been generated if the idle amount had been invested through Xpentra.",
  LINKED_TRANSACTIONS_BLOCK_ARCHIVE:
    "The following transactions are linked and need to be rejected before archiving this account.",
  INTEGRATE_KEY:
    "Enter the key details and integrate it into our system to encrypt banking credential data.",
  TRANSACTION_NEEDS_SECOND_APPROVAL:
    "This transaction has been approved and requires another user's approval before distribution.",
  RECREATE_DESCRIPTION:
    "The following transactions were rejected but their data can be used to recreate new ones.",
  FAILED_DISTRIBUTION_RECREATE_HINT:
    "Distribution of transaction failed due to an error. The data can be used to recreate another.",
  BENEFIT_FULL_CONTROL:
    "Full Control: Use your own encryption key to secure your data. (access, rotation, revocation)",
  NO_STATISTICS_AVAILABLE:
    "No statistics available due to the absence of data. Once data is present, statistics will appear.",
  SLOT_NOT_AVAILABLE:
    "Time slots are not available for the selected start date. Please choose another date to continue.",
  SCHEDULE_REJECTION_ERROR:
    "An error occurred with the following schedules, causing the rejection of all the schedules to fail.",
  ADDITIONAL_DETAILS_DESCRIPTION:
    "Additional details are input fields, that users are required to fill during creation of transaction.",
  LABEL_TOOLTIP_BEHAVIOR:
    "Ensure cards appear in their default state unless hovered and handle excess label chips via tooltip.",
  USE_AUTH_APP_NOTE:
    "Use the authenticator app to scan the QR code shown below, or manually enter the passkey into the app.",
  CONSEQUENCE_RESPONSIBILITY:
    "Increased Responsibility: You’re responsible for managing, rotating, and securing your encryption key.",
  PASSWORD_RESET_WARNING:
    "Note: You will be logged out and required to log in using the new password sent to your email address.",
  TRANSACTION_APPROVAL_NOTE:
    "This transaction has been approved by you, but it requires another user's approval before settlement.",
  PASSWORD_GENERATE_NOTE:
    "Note: You will be logged out and required to log in using the new password sent to your email address.",
  NO_ASSIGNED_CATEGORIES_NOTE:
    "The beneficiary does not currently have any assigned categories. Assign a category in order to proceed.",
  BENE_TRANSACTION:
    "These beneficiary transactions are to be executed today. View and execute reminders or create a new one.",
  STATISTIC_PAGE_NOTE:
    "Click below to open the statistics page, then select ‘Add to home screen.’Added stats will appear here.",
  ASSIGN_CATEGORY_WARNING:
    "The beneficiary currently does not have any assigned categories. Please click edit to assign a category.",
  REQUIRED_BALANCE_NOTE:
    "Transaction will only be executed when source account balance is equal to or more than required balance.",
  ADDITIONAL_RECIPIENTS_CARD_SUBTEXT:
    "The email IDs provided below will be used to send updates and notifications to the selected individuals.",
  REJECTION_ERROR_NOTE:
    "An error occurred with the following transactions, causing the rejection of all the transactions to fail.",
  TAG_INSTRUCTION:
    "These will be used to give access of owner accounts to the users who share even one of the assigned tags.",
  VALID_GST_OR_CLEAR:
    "To proceed either enter a valid GST number associated with the PAN above or clear the field of GST details.",
  SELECT_USERS_TO_TAG:
    "Select users to apply tags. Tagged users will gain access to view owner accounts that share the same tags.",
  DESTINATION_ACCOUNT_CREDIT_NOTE:
    "This account will be credited with the amount once the distribution is completed on the scheduled date(s).",
  MINIMUM_BALANCE_NOTE:
    "The required minimum balance to be maintained in this account and cannot be utilized for any transactions.",
  REJECT_SCHEDULE_CONTACT_NOTE:
    "To reject the schedules, please contact the authorised person who has the feature to reject the schedules.",
  ARCHIVE_DISABLED_EDITING:
    "Archiving this account is disabled. As you're currently editing this account, archiving cannot be performed.",
  BACKUP_CODES_NOTE:
    "Backup codes allow to log in to your account if you're unable to receive TOTP codes from your authenticator app.",
  DEACTIVATE_CATEGORY_POPUP_SUB_POINTS_2:
    "Pending transactions associated with this category will fail upon approval and can be sent for recreation.",
  FILTER_LOGIC_DEV_NOTE:
    "Filters include approval status options such as Approved, Require approval, Pending, Rejected, and Abandoned.",
  CONTACT_TO_REJECT_TRANSACTIONS:
    "To reject the transactions, please contact the authorised person who has the feature to reject the transactions.",
  APPLY_LABELS_NOTE:
    "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions.",
  SELECT_ACCOUNTS_FOR_LABELS:
    "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts.",
  SELECT_ACCOUNTS_TAG_NOTE:
    "Select accounts to apply tags. Tagged accounts will gain access to view owner accounts that share the same tags.",
  SCHEDULE_DETAILS_NOTE:
    "Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency.",
  RTGS_TRANSACTION_NOTE:
    "Note - The transaction amount should be more than 2 lakhs since you have chosen RTGS as the payment method.",
  BENEFIT_SEAMLESS_OPS:
    "Seamless Operations Efficiency: Keep your system running smoothly while protecting your banking credentials.",
  CONSEQUENCE_DATA_LOSS:
    "Potential for Service Disruption: If the key is lost or revoked incorrectly, it could lead to loss of data access.",
  FEATURE_REQUIRED_SERVICES:
    "Feature must include the following services:\nview vendor account\nview vendor transction\ncreate vendor transaction",
  BULK_APPROVAL_ERROR:
    "Approval of the transactions is not possible due to the following errors, their data can be used to recreate new ones.",
  DELETE_SETUP_WARNING:
    "Deleting the setup will remove the key and decrypt your data, leaving it unprotected until re-encrypted with a new key.",
  TOKEN_EXPIRES_WARNING:
    "Session token expires in 8 hours. If token expires, you will have to regenerate session token, as it will not fetch keys.",
  BANK_ALREADY_LINKED_PAN:
    "Looks like this bank account is already linked to the PAN provided. Please change the provided bank details to proceed.",
  CONFIRM_PROCEED:
    "Confirm and click next to proceed. Note that creating a new account adds it to the active accounts for the provided PAN.",
  ACCOUNT_ALREADY_LINKED:
    "Looks like this bank account is already linked to your PAN. Please update either the bank details or your PAN to proceed.",
  NO_EXISTING_ACCOUNT_PAN:
    "There are no existing accounts that are associated with the PAN details provided. You can proceed to create a new account.",
  LABEL_LOGIC_NOTE:
    "Label logic does not duplicate or overwrite existing tags and only displays common labels across selected accounts as selected.",
  CREATE_ACCOUNT_NOTE:
    "On creating a new account, it gets added to the list of active accounts below as a 'pending' account for the PAN and Bank provided.",
  INTEREST_NOTE_6_5:
    "This amount is based on the interest that could have earned by auto-investing using Xpentra, calculated at 6.5% of the idle funds.",
  INTEREST_NOTE_6_51:
    "This amount is based on the interest that could have earned by auto-investing using Xpentra, calculated at 6.51% of the idle funds.",
  INTEREST_NOTE_6_62:
    "This amount is based on the interest that could have earned by auto-investing using Xpentra, calculated at 6.62% of the idle funds.",
  CREATING_JOINT_ACCOUNT_INFO:
    "Creating a new account will transform this account into a joint account and adds it to the active accounts for the provided bank details.",
  ALL_CATEGORIES_UNSAFE:
    "Assigning all categories to a single account is highly unsafe. It is recommended to limit the number of categories assigned to the account.",
  ASSOCIATED_ACCOUNTS_FOUND_UPDATE:
    "Associated accounts have been found, clicking 'update' will add this account to the active accounts associated with the provided PAN details.",
  TAG_ASSIGN_GUIDE:
    "To assign a tag, either select from the list of unassigned tags and assign them or type a new tag name in the search bar and click 'Assign'.",
  SELECT_ALL_CATEGORY_WARNING:
    "Selecting 'Select all' or proceeding without selection implies that these categories, and any future ones added, will be assigned to this user.",
  CONFIDENTIAL_TRANSACTION_NOTE:
    "Transaction will be visible to users with the feature to view confidential transactions.",
  CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE:
    "Enabling confidential transaction will make transaction(s) created by this schedule visible to only those users who have the feature to view confidential transactions.",
  REJECT_ALL_NOTE:
    "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason.",
  BULK_VIEW_ALL_NOTE:
    "Upon successful verification, transactions will be created and sent for approval. If transaction creation is unsuccessful, fix the errors, and upload the corrected data as a new file.",
  UPDATE_TO_JOINT_ACCOUNT_NOTICE:
    "Updating the bank details will transform this account into a joint account since there are several PANs associated with it and adds it to the active accounts for the provided bank details.",
  MUST_RECREATE_BECAUSE_REJECTED:
    "Transaction must be recreated as approval is not possible. To recreate this transaction, you must reject it first. This will remove it from the pending list and move it to the recreate transaction dashboard.",
  POST_APPROVAL_NOTE:
    "Once approved, transaction distribution will get created and auto settled using selected source account. If there are insufficient funds, the transaction will settle once the source account is refilled, and distribution will be initiated thereafter.",
  BYOK_INTRO:
    "Bring Your Own Key (BYOK) is a security model which allows you to use your own encryption keys to secure your credentials, ensuring that only you have access to your sensitive financial data.",
  GET_YOUR_KEY:
    "Generate or retrieve your encryption key from your key management system (KMS) or security provider (e.g., using a service like AWS KMS).",
  KEY_LINKED_SUCCESS:
    "Your encryption key has been successfully linked to your account, ensuring your data (banking credentials) are now securely encrypted with your following AWS key.",
  KEY_INTEGRATION_PROCESS:
    "We’re securely integrating your encryption key with your account. This may take up to 6 mins. Soon your banking credentials will be securely encrypted with your key. Once the setup is complete, you’ll receive a confirmation via mail.",
  RESUME_PROCESS_HINT:
    "Resume the process without starting over. If your session has expired, you will need to re-authenticate and fetch the key again.",
  CONSEQUENCE_NO_PROVIDER_ACCESS:
    "No Provider Access: The service provider cannot access your encrypted data, limiting their ability to troubleshoot or assist with key management.",
  CONSEQUENCE_COMPLEXITY:
    "Key Management Complexity: Requires integration with your key management system and ongoing monitoring.",
  CONSEQUENCE_NO_REVERT:
    "Cannot Revert Back To Our Key: Once data is decrypted on our end, we cannot re-encrypt it using our key. To maintain security, you must re-encrypt the data using your own encryption key.",
  CONFIRM_KNOWLEDGE_TEXT:
    "Before proceeding, please confirm that you’ve read and understood the following: What BYOK is and how it works. The benefits and consequences of using your own encryption key.",
  DELETING_KEY_RISK:
    "Deleting or losing access to the key may result in permanent data loss. To maintain data security, ensure the key remains active in your AWS server.",
  ENCRYPTION_FAILED_REASON:
    "The encryption process was unsuccessful. This may be due to a session timeout, incorrect key details, or a system issue. Kindly retry again.",
  BANKING_ONLY_REASON:
    "Encrypting just your banking credentials ensures smooth and uninterrupted operations for the system to function properly. This way, your sensitive financial information stays secure, while the rest of the system remains fully operational for your team, maintaining both security and efficiency.",
  TAG_ASSIGNMENT_HINT:
    "To assign a tag, either select from the list of unassigned tags and assign them or type a new tag name in the search bar and click ‘Assign’.",
  INSTALL_AUTHENTICATOR_INSTRUCTIONS:
    "Install a TOTP-compatible authenticator app on your mobile, tablet or desktop device this will generate TOTP code which will be required for registration and then every time you login.",
  STATISTICS_TOP_HEADER_TEXT: "The entity's statistical data is listed below.",
  BANKING_CREDENTIALS_ENCRYPTION_INFO:
    "Encrypting just your banking credentials ensures smooth and uninterrupted operations for the system to function properly. This way, your sensitive financial information stays secure, while the rest of the system remains fully operational for your team, maintaining both security and efficiency.",

  CHANGE: "Change",
  DEACTIVATE: "Deactivate",
  DEACTIVATE_CATEGORY_POPUP_SUB_POINTS_3:
    "New accounts and transactions will not have this category available for selection.",
  ACTIVATE: "Activate",
  CATEGORY_SMALL: "category",
  DEFAULT_SMALL: "default",

  OTHER_EXISTING_INTERNAL_ACCOUNTS_FOUND:
    "Other existing internal accounts found",
  Reimbursement_Details: "Reimbursement Details",
  //Nav Bar
  NAVBAR_WARNING: "*If disabled - the feature is not available for your ID.",
  FROM_DATE: "From date",
  TO_DATE: "To date",
  SELECT_DATE: "Select date",
  SOURCE_AND_DESTINATION: "Source and destination account",
  ADDITIONAL_DETAILS_AND_LABELS: "Additional details and labels",

  //MIS Report

  FILTER_COLUMN_INFO:
    "No filter added. Click ‘Add filter’ to select and apply a filter to this report.",
  FILTER_BY_OPTIONAL_CAMELCASE: "Filter By (Optional)",

  PRIVATE_TXN_STEP0_SELECT_TO_UPLOAD:
    "Select a category to upload a transaction file or download a sample.",
  PRIVATE_TXN_STEP0_NOTE1:
    "All beneficiaries in the file must be approved beneficiary accounts on Xpentra.",
  PRIVATE_TXN_STEP0_NOTE2:
    "For successful transaction verification, please make sure to follow the sample file format.",
  UPLOAD_FILE: "Upload File",
  FILE_VERIFICATION_PROCESS_POST_UPLOAD:
    "File verification process post upload:",
  FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG1:
    "Our system validates the values in each row. If any errors are identified, or If even one beneficiary in the file is not pre-approved, the entire file will get rejected.",
  FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG2:
    "After the file is processed, you will be notified by an email notification.",
  FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG3:
    "Once successful processing, the file will require validation, approval, and OTP verification.",
  FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG4:
    "After OTP verification is complete, a single transaction will be generated for the total amount.",
  SOURCE_ACCOUNT_USAGE_NOTE_FILE:
    "This account will be used to settle the transaction in this file.",
  PRIVATE_TXN_LABELS_USAGE_NOTE:
    "These will be used to generate statistics for the associated transaction.",
  PRIVATE_TXN_LABELS_AUTO_ASSIGNED_NOTE:
    "The labels below are auto assigned as per selected owner account.",
  CREATE_PRIVATE_TXN: "Create private transaction",

  //Private Transaction Flow
  FILE_PROCESSED: "File has been processed. Validation pending",
  PRIVATE_TXN_APPROVAL_NOTE:
    "This transaction has been approved by you and requires another user's approval.",
  PRIVATE_TXN_AUTHENTICATION_NOTE:
    "This transaction has been approved, authenticate to create a transaction.",
  PRIVATE_TXN_SUCCESS_NOTE: "Transaction created successfully.",
  ERROR_SUMMARY: "Error summary",
  FILE_PROCESSING: "File processing",
  FILE_PROCESSING_MESSAGE:
    "You will receive a notification by mail once the file is processed.",
  PENDING_VALIDATION: "Validation pending",
  REQUIRE_VALIDATION: "Require validation",
  VALIDATE_FILE: "Validate file",
  AUTH_REQUIRE: "Require authentication",
  AUTH_Pending: "Authentication pending",
  AUTH_REQUIRE_MSG:
    "This transaction has been approved. Authentication pending",
  AUTH_OTP: "Authenticate with OTP",
  REASON_10_150_CHAR: "Reason (10-150 char)",
  REJECTION_REASON_NOTE_WO_NOTE:
    "The reason must consist of at least 10 characters.",

  REJECTION_REASON_PROMPT_SCHEDULE:
    "Please state the reason for rejecting the schedule.",

  REJECTION_REASON_PROMPT_REIMBURSEMENT:
    "Please state the reason for rejecting the transaction.",

  // Virtual account
  MARK_VIRTUAL_ACCOUNT: "Mark It As Virtual Account",
  VIRTUAL_ACCOUNT_NOTE:
    "Transactions from this account will be created without bank verification. Self-verify and proceed with caution.",
};
